import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.replace";
import debounce from 'lodash/debounce'; // import browserMD5File from 'browser-md5-file';

var isStr = function isStr(s) {
  return typeof s === 'string';
}; // 组件共享状态：OSS 上传签名


var oss = {
  accessid: '',
  // 16 位字符串
  callback: '',
  dir: '',
  // 上传路径
  expire: '',
  // 13 位毫秒数
  host: '',
  // 阿里云 OSS 地址
  name: '',
  policy: '',
  // Base64 编码字符串
  random: '',
  signature: '',
  // 28 位字符串
  userid: ''
};
export default {
  props: {
    // 获取签名url
    url: {
      type: String,
      required: true
    },
    // 【注意】该项请使用 .sync 修饰，形式可为 'url' 或 ['url1', 'url2', ...]
    files: {
      type: [String, Array],
      required: true
    },
    payload: {
      // 额外传送的data
      type: Object
    }
  },
  data: function data() {
    return {
      oss: oss,
      key: '',
      // 正在上传的文件的 key（computed:access 依赖项）
      file: null,
      filename: '',
      percent: 0,
      // 当前任务上传进度
      taskQueue: [],
      // 上传队列（基于 Promise 实现）
      isUploading: false,
      fileList: [] // 用于 ElUpload 组件的 $props.fileList

    };
  },
  computed: {
    action: function action() {
      // 用于 ElUpload 组件的 $props.action
      return oss.host.replace(/^http:/, location.protocol); // 支持https协议
    },
    access: function access() {
      // 用于 ElUpload 组件的 $props.data
      return Object.assign({}, this.payload, {
        key: this.changeDocExtension(this.key),
        callback: oss.callback,
        policy: oss.policy,
        signature: oss.signature,
        OSSAccessKeyId: oss.accessid,
        success_action_status: 200,
        'x:isneedsave': 1,
        'x:userid': oss.userid,
        'x:name': this.file ? this.filename : ''
      });
    }
  },
  watch: {
    files: {
      handler: function handler(files) {
        if (isStr(files)) {
          if (files.length > 0) {
            files = [files];
          } else {
            files = [];
          }
        } else if (files instanceof Array) {
          files = files.filter(function (f) {
            return f.length;
          });
        } else {
          files = [];
        } // 遵循 ElUpload 的 $props.fileList 的 [{ name, url }] 格式


        this.fileList = files.map(function (url, idx) {
          return {
            name: '' + idx,
            url: url
          };
        });
      },
      immediate: true
    },
    isUploading: function isUploading(_isUploading) {
      var _this = this;

      // isUploading 从 true 变成 false 时，在 nextTick 中同步 ElUpload $data.uploadFiles 到 $props.files
      // 为什么要 nextTick？因为 onSuccess 中执行 this.nextFile() 之后还有 file.url = uploadFile 的操作
      _isUploading || this.$nextTick(function () {
        _this.syncUploadFiles();
      });
    }
  },
  methods: {
    /**
     * 【注意：该方法须自行实现】新增上传任务，用于 ElUpload 组件的 before-upload 钩子函数，举例如下：
     * @param  {File}
     * @return {Boolean/Promise} - 官方文档写道：若返回 false 或者 Promise 则停止上传
      beforeUpload (file) {
        // 此处进行检测 file 合法性等操作，之后就只需要调用如下函数即可
        return this.addFile(file)
      }
     */
    syncUploadFiles: function syncUploadFiles() {
      // 这里最后意为排除掉 blob 开头的 URL（这算是一个坑），此时 files 有可能是空数组
      var files = this.$refs.upload.uploadFiles.map(function (_ref) {
        var url = _ref.url;
        return url;
      }).filter(function (url) {
        return url.startsWith('http');
      }); // 对于无论是否 multiple，ElUpload 的 $data.uploadFiles 始终都是数组类型
      // 因此若 $props.files 为字符串类型，则应取 files 的末位元素（注：空数组时取得 undefined）

      this.$emit('update:files', isStr(this.files) ? files.slice(-1)[0] || '' : files);
    },
    // 用于 ElUpload 的 on-progress
    onProgress: function onProgress(_ref2) {
      var percent = _ref2.percent;
      this.percent = ~~percent;
    },
    // 用于 ElUpload 的 on-success
    onSuccess: function onSuccess(res, file, uploadFiles) {
      var uploadPath = this.nextFile();
      file.url = uploadPath; // 把 blob 链接替换成 CDN 链接
    },
    // 用于 ElUpload 的 on-remove
    onRemove: debounce(function () {
      var _this2 = this;

      // 手动点击删除显然会调用本函数，但如下场景也会触发调用：
      // 限制 5 张，已传 3 张，若在文件管理器中再选 10 张上传
      // 则溢出了 8 张，即本函数将会频繁调用 8 次（所以要 debounce 一下）
      // 若本函数仅仅就是单纯执行 syncUploadFiles，则必然报错：
      // Uncaught TypeError: Cannot set property 'status' of null
      //
      // 因为此时正在上传 2 张，ElUpload 内部的 handleProgress 一直在不断执行
      // 若直接就粗暴地调用 syncUploadFiles 则会触发 ElUpload $data.uploadFiles 的更新
      // 导致 handleProgress 中的 var file = this.getFile(rawFile) 为 null
      // 故随后 file.status = 'uploading' 就会立即报错
      // （详见源码 https://github.com/ElemeFE/element/blob/1.x/packages/upload/src/index.vue#L141-L146）
      this.isUploading ? setTimeout(function () {
        return _this2.onRemove;
      }, 1000) : this.syncUploadFiles();
    }, 250),
    // 用于 ElUpload 的 on-error（一般是 OSS access 过期了）
    onError: function onError(err) {
      if (__DEV__) {
        console.log(err);
      }

      this.isUploading = false; // 重置上传状态很关键，否则之后就不能 auto run 了

      this.$message.warning('上传功能出了点问题，请重试');
    },
    addFile: function addFile(file) {
      var _this3 = this;

      var filenameArr = file.name.split('.');
      var ext = filenameArr.pop().toLowerCase();
      this.filename = "".concat(filenameArr.join('.'), ".").concat(ext);
      return new Promise(function (resolve) {
        _this3.taskQueue.push({
          file: file,
          start: resolve
        }); // auto run


        if (!_this3.isUploading) {
          _this3.isUploading = true;

          _this3.nextFile(true);
        }
      });
    },
    nextFile: function nextFile(isAutorun) {
      var _this4 = this;

      // 当 isUploading false => true 时（auto run）：
      // 1. 若之前没有上传过的，则 this.action 和 this.key 均为 ''，故 join 出来是 '/'
      // 2. 若之前有上传过的，则结果为上一次的 uploadPath
      // 鉴于两者都没有意义，故由 auto run 触发的都无需执行 urljoin
      var uploadPath;

      if (!isAutorun) {
        uploadPath = "".concat(this.action, "/").concat(this.key);
      } // 开发环境下打印出刚上传成功的文件链接以便调试
      // （为什么不写成 if(__DEV__ && !isAutorun)？因为有利于 UglifyJS 压缩时直接剔除整块代码 ）


      if (__DEV__) {
        if (!isAutorun) {
          console.info('上传成功：', uploadPath);
        }
      }

      var taskQueue = this.taskQueue;

      if (taskQueue.length) {
        var ensureAccessValid = isAccessExpired() ? updateAccess : doNothing;
        var nextTask;
        ensureAccessValid.call(this).then(function () {
          nextTask = taskQueue.shift();
          _this4.file = nextTask.file;
          return keygen(nextTask.file, 16);
        }).then(function (key) {
          _this4.key = key; // 更新 key 以更新 computed:access

          _this4.$nextTick(function () {
            nextTask.start(); // 相当于 resolve 掉 before-upload 钩子中返回的 promise
          });
        }).catch(function (e) {
          return console.warn(e);
        });
      } else {
        this.isUploading = false;
      }

      return uploadPath;
    },
    // 改变文件后缀
    changeDocExtension: function changeDocExtension(key) {
      if (key == '') {
        return key;
      } else {
        var list = key.split('.');
        var name = list[0];
        var docextension = list[1];
        key = name + '.' + docextension.toLowerCase();
        return key;
      }
    }
  }
}; // 判断 access 是否过期（提前 10 秒过期）

function isAccessExpired() {
  var timestamp = Date.parse(new Date()) / 1000;
  return oss.expire < timestamp + 10;
}
/**
 * 更新 OSS access
 * @return {Promise}
 */


function updateAccess() {
  return this.$http.get(this.url).then(function (ret) {
    if (ret && typeof ret.expire === 'string') {
      ret.expire = Date.parse(new Date(ret.expire)) / 1000;
    }

    Object.assign(oss, ret);
  });
}

function doNothing() {
  return Promise.resolve();
}
/**
 * 生成上传 key（基于文件哈希）
 * @param   {File}
 * @resolve {String} 形如 '<上传路径>/3d3e93a9745fd21240ef3c88045cc0d1.jpg'
 */
// function keygen(file) {
//   return new Promise((resolve, reject) => {
//     browserMD5File(file, (err, md5) => {
//       if (err) {
//         reject(err);
//         return;
//       }
//       resolve(
//         urljoin(oss.dir, `${md5}.${file.name.split('.').pop()}`)
//       );
//     });
//   });
// }

/**
 * 生成上传 key（基于文件哈希）
 * @param   {File}
 * @resolve {String} 形如 '<上传路径>/3d3e93a9745fd21240ef3c88045cc0d1.jpg'
 */


function keygen(file, len) {
  len = len || 128;
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = chars.length;
  var fileName = '';

  for (var i = 0; i < len; i++) {
    fileName += chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return new Promise(function (resolve) {
    resolve("".concat(oss.dir).concat(fileName, ".").concat(file.name.split('.').pop().toLowerCase()));
  });
}